import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function FounderStory() {
  const [text, setText] = useState("");

  useEffect(() => {
    api.get("/site/founder-story").then((r) => setText(r.data.text || "")).catch(() => {});
  }, []);

  if (!text) return null;
  return (
    <section className="mt-20 max-w-2xl" data-testid="about-founder-story">
      <p className="font-sans uppercase tracking-[0.28em] text-xs text-terracotta mb-5">Why I built Umbra</p>
      {text.split(/\n\s*\n/).map((para, i) => (
        <p key={i} className="font-serif text-lg sm:text-xl text-bone-200 leading-relaxed mb-5" data-testid={`about-founder-story-p-${i}`}>
          {para}
        </p>
      ))}
    </section>
  );
}
